import React, { useEffect } from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'

export const FontAwesomeIcon = ({ children, className, icon, tooltipText, ...props }) => {
  const classNames = classnames('fa', className, { [`fa-${icon}`]: true })
  return (
    <i className={classNames} data-tip={tooltipText} {...props}>{children}</i>
  )
}

FontAwesomeIcon.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  icon: PropTypes.string.isRequired
}
